// Languages offered on the Security Service Provider application.
//
// `nativeName` is what the switcher shows — always the language's own name, never
// the English one. Someone who can't read the form can't read "Spanish" either.
// No flags: a flag names a country, not a language (Spanish is not Spain's alone,
// and French here is far more often Haitian than Parisian).
//
// Codes are plain ISO-639-1 with no region subtag on purpose. Portuguese is
// written in Brazilian Portuguese — the overwhelming majority of Portuguese
// speakers in South Florida — but is served to every `pt-*` browser rather than
// falling back to English for a `pt-PT` visitor.
// Named UI_LANGUAGES, not LANGUAGES: utils/constants.jsx already exports a
// LANGUAGES list of languages an applicant may *speak*, which is a different
// thing from the languages the interface is available in.
export const UI_LANGUAGES = [
  { code: 'en', nativeName: 'English' },
  { code: 'es', nativeName: 'Español' },
  { code: 'ht', nativeName: 'Kreyòl Ayisyen' },
  { code: 'pt', nativeName: 'Português' },
  { code: 'fr', nativeName: 'Français' },
  { code: 'ru', nativeName: 'Русский' },
];

export const LANGUAGE_CODES = UI_LANGUAGES.map((l) => l.code);

export const DEFAULT_LANGUAGE = 'en';

// Functional (strictly-necessary) preference storage. Remembering the language
// someone picked is required for the form to work for them at all, so this is
// not a consent-gated key — but it is disclosed in the Cookie Policy.
export const LANGUAGE_STORAGE_KEY = 'guardly_lang_v1';

export const nativeNameOf = (code) =>
  UI_LANGUAGES.find((l) => l.code === code)?.nativeName || code;
